var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialogo__chat dialogo__chat--no-scroll p-4 me-0"},_vm._l((_vm.dialogoComputed),function(dialogoItem){return _c('DialogoBurbuja',{key:`dialogo-item-${dialogoItem.id}`,staticClass:"mb-3",attrs:{"dialogoItem":dialogoItem}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }